var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDomainAdmin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 22,
    viewBox: "0 0 19 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#6B696A",
    d: "M4.702 9.406C2.109 9.406 0 7.297 0 4.703 0 2.11 2.109 0 4.702 0c2.594 0 4.703 2.11 4.703 4.703 0 2.594-2.109 4.703-4.703 4.703m0-8.304c-1.985 0-3.601 1.616-3.601 3.601 0 1.986 1.616 3.6 3.601 3.6 1.985 0 3.602-1.614 3.602-3.6 0-1.985-1.617-3.601-3.602-3.601",
    transform: "translate(-670 -53) translate(670.435 53.79) translate(4.302 2.263)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#6B696A",
    strokeWidth: 0.5,
    d: "M4.702 9.406C2.109 9.406 0 7.297 0 4.703 0 2.11 2.109 0 4.702 0c2.594 0 4.703 2.11 4.703 4.703 0 2.594-2.109 4.703-4.703 4.703m0-8.304c-1.985 0-3.601 1.616-3.601 3.601 0 1.986 1.616 3.6 3.601 3.6 1.985 0 3.602-1.614 3.602-3.6 0-1.985-1.617-3.601-3.602-3.601",
    transform: "translate(-670 -53) translate(670.435 53.79) translate(4.302 2.263)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#6B696A",
    d: "M18.007 19.677c-.041-3.639-2.25-6.763-5.393-8.144-.351.29-.738.537-1.152.738 3.126 1.025 5.399 3.95 5.442 7.405H1.105c.044-3.454 2.316-6.38 5.442-7.405-.414-.2-.801-.449-1.152-.739C2.251 12.915.043 16.038.002 19.678H0v1.1h18.009v-1.1h-.002z",
    transform: "translate(-670 -53) translate(670.435 53.79)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#6B696A",
    strokeWidth: 0.5,
    d: "M18.007 19.677c-.041-3.639-2.25-6.763-5.393-8.144-.351.29-.738.537-1.152.738 3.126 1.025 5.399 3.95 5.442 7.405H1.105c.044-3.454 2.316-6.38 5.442-7.405-.414-.2-.801-.449-1.152-.739C2.251 12.915.043 16.038.002 19.678H0v1.1h18.009v-1.1h-.002z",
    transform: "translate(-670 -53) translate(670.435 53.79)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#368FEF",
    d: "M10.817 18.664L7.193 18.664 8.401 13.429 9.609 13.429z",
    transform: "translate(-670 -53) translate(670.435 53.79)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#368FEF",
    strokeWidth: 0.5,
    d: "M10.817 18.664L7.193 18.664 8.401 13.429 9.609 13.429z",
    transform: "translate(-670 -53) translate(670.435 53.79)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#368FEF",
    d: "M3.478 5.678L14.532 5.678 14.532 0 12.689 2.567 9.216 0 6.408 2.567 3.478 0z",
    transform: "translate(-670 -53) translate(670.435 53.79)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#368FEF",
    strokeWidth: 0.5,
    d: "M3.478 5.678L14.532 5.678 14.532 0 12.689 2.567 9.216 0 6.408 2.567 3.478 0z",
    transform: "translate(-670 -53) translate(670.435 53.79)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDomainAdmin);
export default __webpack_public_path__ + "static/media/domain_admin.73c032020a247474538879d107c0a382.svg";
export { ForwardRef as ReactComponent };